/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'getSystemTicketNumberPluginPermutationModelsByN',
    message: messages.SUCCESS_GET_SYSTEM_TICKET_NUMBER_PLUGIN_PERMUTATION_MODELS_BY_N,
    method: 'GET',
    path: '/system/:systemId/ticket-number-plugin-permutation-models/:n',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_SYSTEM_TICKET_NUMBER_PLUGIN_PERMUTATION_MODEL,
    requestSchema: requestSchemas.systemTicketNumberPlugins.getSystemTicketNumberPluginPermutationModelsByN,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'getSystemTicketNumberPluginRunningModelsByN',
    message: messages.SUCCESS_GET_SYSTEM_TICKET_NUMBER_PLUGIN_RUNNING_MODELS_BY_N,
    method: 'GET',
    path: '/system/:systemId/ticket-number-plugin-running-models/:n',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_SYSTEM_TICKET_NUMBER_PLUGIN_RUNNING_MODEL,
    requestSchema: requestSchemas.systemTicketNumberPlugins.getSystemTicketNumberPluginRunningModelsByN,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'getSystemTicketNumberPluginsByN',
    message: messages.SUCCESS_GET_SYSTEM_TICKET_NUMBER_PLUGINS_BY_N,
    method: 'GET',
    path: '/system/:systemId/ticket-number-plugins/:n',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_SYSTEM_TICKET_NUMBER_PLUGIN,
    requestSchema: requestSchemas.systemTicketNumberPlugins.getSystemTicketNumberPluginsByN,
    scopes: [scopes.DEFAULT],
  },
];
